import Flex from '@Components/Bases/Flex';
import { CheckCircle, Circle, PriorityHigh } from '@mui/icons-material';

export interface CheckProgressProps {
  isPass?: boolean;
  isPublished?: boolean;
  disabled?: boolean;
  score?: number;
}

const CheckProgress = ({
  isPass = false,
  isPublished = false,
  disabled = false,
  score,
}: CheckProgressProps) => {
  const showCheckCircle = isPublished || isPass;

  const iconColor = (() => {
    if (disabled) {
      return 'grey.300';
    }

    if (score && isPass) {
      return 'success.main';
    }

    if (showCheckCircle) {
      return 'success.main';
    }

    return 'info.main';
  })();

  const renderIcon = () => {
    if (showCheckCircle) {
      return <CheckCircle sx={{ color: iconColor }} />;
    }

    if (score !== undefined && score < 90) {
      return (
        <Flex
          width={20}
          height={20}
          borderRadius={100}
          bgcolor={'warning.main'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <PriorityHigh sx={{ color: 'white' }} fontSize="small" />
        </Flex>
      );
    }

    return <Circle sx={{ color: iconColor }} />;
  };

  return <Flex pr={1}>{renderIcon()}</Flex>;
};

export default CheckProgress;
